import React, { Component } from "react";
import { connect } from "react-redux";
import CreatePromotion from "../../store/prat_middleware/promotion/createPromotionMiddleware";
import ProductDetail from "./productDeatil";
import ChannelDetail from "./channelDetail";
import Duration from "./duration";
import GeographicDetail from "./geographicDetail";
import Outlet from "./outlet";
import Promotion from "./promotion";
import "./style/gt_form.scss";
import { openDB } from "idb";
import { Loader } from "../../components/loader";
import ApprovalsMiddleware from "../../store/prat_middleware/promotion/approvalsMiddleware";
import ApprovalHistory from "../../components/approval-history/ApprovalHistroy";
import ApprovalsMiddelware from "../../store/prat_middleware/promotion/approvalsMiddleware";
import GtFormHelpers_submitHelper from "./helpers/gtFormHelpers";
import SaveDraft from "./helpers/saveDraftHelper";
import CustomToast from '../../util-functions/customToast.jsx';
import ContributionDetail from './contributionDetail';
import MTFTSPromotion from './mtftsPromotion';

let isPromotion_create = true;
let mainMetaDataChangeFlag = null;
class GtForm extends Component {
  is_Mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: "",
      product: "",
      multiSelect: [],
      istrue: false,
      counter: 0,
      next: 0,
      sync: false,
      productDetail_status: "isPass",
      geoDetail_status: "isPass",
      outletDetail_status: "isPass",
      durationDetail_status: "isPass",
      channelDetail_status: "isPass",
      durationData_props: undefined,
      newto_savedraft: false,
      promotion_data: undefined,
      isSaveDraft: false,
      isLoading: false,
      isdraft_iscreatePromotion: false,
      fetching_promotionData: false,
      ANP: "",
      submitActivity_Status: "initial",
      formName: "",
      outletCodes: null,
      saveOutletCodesDraft: null,
      isNew_Restrict: "",
      preOpso_data: undefined,
      pushed_to_dwh: false,
      isDw_forProm: false,
      isPush_For_saveDraft: false,
      currentActivityStatus: "",
      openHistory: false,
      msku_name: [],
      isExtend: false,
      isExtednNewPromotion: false,
      isInvoiceOn: true,
      productDetailPromoType: '',
      isCalculateBtnClicked: false
    };
  }

  componentDidMount() {

    this.is_Mounted = true;
    SaveDraft.del_restriction_fromIdb(); // delete validation (change in meta data after create promotion ) on did mount
    let pathParam = window.location.href.substring(
      // to check gt or mt
      window.location.href.lastIndexOf("/") + 1,
      window.location.href.length
    );
    this.setState({ formName: pathParam });
    let activityStatus = window.location.href.substring(
      window.location.href.lastIndexOf("=") + 1,
      window.location.href.lastIndexOf("/")
    ); // activity status checking
    let cropStatus = activityStatus.replace(/%20/g, " ");
    this.setState({
      currentActivityStatus: cropStatus,
    });

    setTimeout(() => {

      let getdraft_id = window.location.pathname.substr(8);
      this.props.getSendBackHistory(getdraft_id);
      this.props.get_saveDraft(getdraft_id);
      this.setState({ isLoading: true, isSaveDraft: false });
      if (this.props.draftData) {
        this.setState({ isSaveDraft: false });
      }
      if (!window.location.search) {
        this.setState({ isLoading: false });
      }

      this.forceUpdate();
      isPromotion_create = true;
    }, 1000);
  }



  onSubmit() {
    this.handleIsCalculateButtonClicked(false);
    if (this.state.isSaveDraft === true) {
      // if promotion is not created
      this.setState({ isdraft_iscreatePromotion: true });
      this.saveDraft(this.state.isSaveDraft);
    } else {
      if (this.props.draftData?.IsExtended === true || this.props.draftData?.CanSubmit) {
        this.setState({ isExtednNewPromotion: true, isLoading: true })
        let calculate = {
          _id: this.props.draftData?.guid,
          PreOpso: {
            PreOpso: this.props.draftData.PreOpso,
          },
        };
        // this.handle_createPromotion(this.props.draftData);
        this.props.post_calculate_preOpso(calculate)  // temp commit to use create promo API
      }
      else if (this.props.draftData && !this.props.promotionData) {
        this.handle_createPromotion(this.props.draftData); // to create promotion
      } else {
        this.setState({ isdraft_iscreatePromotion: true });
        this.saveDraft(true);
      }
    }
  }

  handle_createPromotion(draft_data) {
    this.setState({ counter: 4, next: 4 });
    const getData = async (draft_data) => {
      draft_data = draft_data?.ActivityMetadata;
      if (this.state.formName !== "mt") {
        draft_data.channel_detail =
          draft_data?.channel_detail.length === 0 ? {} : draft_data.channel_detail;
      }
      if (this.state.formName !== "mt") {
        draft_data.outlet_attributes =
          draft_data?.outlet_attributes.length === 0
            ? {}
            : draft_data.outlet_attributes;
      }
      let promotion_type = false;
      // following if condition code are checking if any field is not slected in product detail
      if (draft_data?.product_detail) {
        let values = draft_data?.product_detail;
        promotion_type =
          values?.promotion_type === "b0107ffd-5026-4011-bdc6-3bb2e5986332"
            ? true
            : false;
        if (values?.divisions === "") {
          CustomToast('error', "Hey, you just Leave mandatory field 'Product Divisions' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
        //this validation block is for MT form where it check if customer select is null or any 
        if (this.state.formName === "mt" && values?.direct_customers.length === 0) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Customer' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
        if (values?.categories.length === 0) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Product Category' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
        if (
          values?.brands.length === 0 &&
          values?.promotionLevelType !== "CATEGORY"
        ) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Product Brands' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
        if (
          values?.sectors.length === 0 &&
          this.state.formName === "ic" &&
          (values?.promotionLevelType === "MASTERSKU" ||
            values?.promotionLevelType === "SKU" ||
            values?.promotionLevelType === "SECTOR")
        ) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Product Sectors' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
        if (
          values?.master_skus.length === 0 &&
          (values?.promotionLevelType === "MASTERSKU" ||
            values?.promotionLevelType === "SKU")
        ) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Product Master Skus' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
        if (values?.skus.length === 0 && values.promotionLevelType === "SKU") {
          CustomToast('error', "Hey, you just Leave mandatory field 'Product Skus' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
        if (values.promotion_as === "") {
          CustomToast('error', "Hey, you just Leave mandatory field 'Run Promotion as' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
        if (values.sbb_type === "") {
          CustomToast('error', "Hey, you just Leave mandatory field 'SBB Type' empty !")
          return this.setState({ productDetail_status: "failed" });
        } else {
          this.setState({ productDetail_status: "isPass" });
        }
      }

      // following if condition code are checking if any field is not slected in geographic detail

      if (draft_data?.geographic_detail) {
        let values = draft_data?.geographic_detail;
        if (values?.regions?.length === 0) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Geo regions' empty !")
          return this.setState({ geoDetail_status: "failed" });
        } else {
          this.setState({ geoDetail_status: "isPass" });
        }
        if (values?.territories?.length === 0 && (this.state.formName === "gt" || this.state.formName === "ic")) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Geo territory' empty !")
          return this.setState({ geoDetail_status: "failed" });
        } else {
          this.setState({ geoDetail_status: "isPass" });
        }
        if (values?.towns?.length === 0 && (this.state.formName === "gt" || this.state.formName === "ic")) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Geo Towns' empty !")
          return this.setState({ geoDetail_status: "failed" });
        } else {
          this.setState({ geoDetail_status: "isPass" });
        }
        if (values?.distributors?.length === 0) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Geo Distributors' empty !")
          return this.setState({ geoDetail_status: "failed" });
        } else {
          this.setState({ geoDetail_status: "isPass" });
        }
      }

      // following if condition code are checking if any field is not slected in channel detail

      if (draft_data?.channel_detail) {
        let value = draft_data?.channel_detail;
        if (value?.master_channels?.length === 0) {
          CustomToast('error', "Hey, you just Leave mandatory field 'Master Channel' empty !")
          return this.setState({ channelDetail_status: "failed" });
        } else {
          this.setState({ channelDetail_status: "isPass" });
        }
      }

      // following if condition code are checking if any field is not slected in outlet detail

      if (this.state.formName === "gt") {
        if (
          draft_data?.outlet_attributes &&
          draft_data?.channel_detail
        ) {
          let channelValue = draft_data?.channel_detail;
          let value = draft_data?.outlet_attributes;
          let isEmpty = Object.values(value);


          if (
            (channelValue?.master_channels?.length !== 0 &&
              value?.channel_tts?.length === 0 &&
              promotion_type === false) ||
            (isEmpty.length === 0 && promotion_type === false)
          ) {
            CustomToast('error', "Hey, you just Leave mandatory field 'Channel Tts' empty !")
            return this.setState({ outletDetail_status: "failed" });
          } else {
            this.setState({ outletDetail_status: "isPass" });
          }
        }
      } else {
        this.setState({ outletDetail_status: "isPass" });
      }

      // following if condition code are checking if any field is not slected in duration detail

      if (draft_data?.duration_detail) {
        let value = draft_data?.duration_detail;

        let isEmpty = Object.values(value);
        if (isEmpty.length === 0) {
          CustomToast('error', "Please choose any valid week or date ")
          return this.setState({ durationDetail_status: "failed" });
        } else if (value.IsDate === false) {
          if (value.WeekStart === "" || !value.WeekStart) {
            CustomToast('error', "Hey, you just Leave mandatory field 'Week From' empty !")
            return this.setState({ durationDetail_status: "failed" });
          } else if (value.WeekEnd === "" || !value.WeekEnd) {
            CustomToast('error', "Hey, you just Leave mandatory field 'Week To' empty !")
            return this.setState({ durationDetail_status: "failed" });
          }
        } else if (value.IsDate === true) {
          if (value.DateStart === "" || !value.DateStart) {
            CustomToast('error', "Hey, you just Leave mandatory field 'Date start' empty !")
            return this.setState({ durationDetail_status: "failed" });
          } else if (value.DateEnd === "" || !value.DateEnd) {
            CustomToast('error', "Hey, you just Leave mandatory field 'Date end' empty !")
            return this.setState({ durationDetail_status: "failed" });
          }
        } else {
          this.setState({ durationDetail_status: "isPass" });
        }
      }

      if (!draft_data) {
        CustomToast('error', "All mandatory fields required ")
      } else {
        let getId = window.location.pathname.substr(8);
        mainMetaDataChangeFlag = this.mainMetaDataChangeCheck(this.props.draftData, draft_data?.product_detail, draft_data?.duration_detail, draft_data?.geographic_detail);
        let checkFlag = (this.props.draftData?.main_metadata_changed === false && mainMetaDataChangeFlag === false) ? false :
          (this.props.draftData?.main_metadata_changed === true && (mainMetaDataChangeFlag === true || mainMetaDataChangeFlag === false)) ? true :
            // (this.props.draftData?.main_metadata_changed === true && mainMetaDataChangeFlag === false) ? true :
            mainMetaDataChangeFlag
        if (getId) {
          this.setState({ isLoading: true });
          let apiBody = { key: getId, data: { ActivityMetadata: draft_data, main_metadata_changed: checkFlag } };
          setTimeout(() => {
            if (this.state.formName === "mt") {
              this.props.createPromotionmtfts(apiBody);
            } else {
              this.props.createPromotion(apiBody);
            }
          }, 2000);
        }
      }
    };
    getData(draft_data);
  }

  PreOpsoData(data, flag) {
    const saveData = async (data, flag) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);       // eslint-disable-line
        },
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);
      const value = await store.put(
        { key: "pre_123", value: data },
        "preopso_detail"
      );
      const isSave = await store.put(
        { key: "draft_123", value: flag },
        "is_draft_saved"
      );
      await tx.dones;
      let resp;
      let txs;
      let obj;
      resp = await db;
      txs = await resp.transaction(storeName);
      obj = await txs.objectStore(storeName);
      let productDataResult = await obj.get(value);
      let draft = await obj.get(isSave);       // eslint-disable-line
      let preOpsoData = productDataResult ? productDataResult.value : [];       // eslint-disable-line
      draft = draft ? draft.value : [];
    };

    saveData(data, flag);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.draftData !== this.props.draftData) {
      if (this.props.draftData.guid) {
        if (this.props.draftData?.IsExtended === true && this.state.isExtend === false) {
          this.setState({ isExtend: this.props.draftData?.IsExtended })
          this.props.getOldPreopso(window.location.pathname.substr(8));
        }
        if (this.state.formName === 'mt') {
          isPromotion_create = //to handle metadata change  validation
            isPromotion_create === false
              ? false
              : this.props.draftData?.PreOpso?.Promotions
                ? true
                : this.state.counter !== 5
                  ? false
                  : true;
        }
        else {
          isPromotion_create = //to handle metadata change  validation
            isPromotion_create === false
              ? false
              : this.props.draftData?.PreOpso?.Promotions
                ? true
                : this.state.counter !== 5
                  ? false
                  : true;
        }

        this.setState({
          isSaveDraft: false,
          isLoading: false,
          isdraft_iscreatePromotion: false,
          preOpso_data: this.props.draftData?.PreOpso,
        });
        if (
          this.state.submitActivity_Status !== "execute" &&
          this.state.submitActivity_Status !== "initial"
        ) {
          this.post_submitApi(this.state.isPush_For_saveDraft);
        }

        if (this.state.isdraft_iscreatePromotion === true) {
          let data = this.props.draftData?.ActivityMetadata;
          if (
            data?.product_detail &&
            data?.geographic_detail &&
            data?.channel_detail &&
            data?.outlet_attributes &&
            data?.duration_detail
          ) {
            if (this.props.draftData?.IsExtended === true || this.props.draftData?.CanSubmit) {
              this.setState({ isExtednNewPromotion: true, isLoading: true })
              // let calculate = {
              //   _id: this.props.draftData?.guid,
              //   PreOpso: {
              //     PreOpso: this.props.draftData.PreOpso,
              //   },
              // };  // temp commit to use create promo API
              this.handle_createPromotion(this.props.draftData);
              // this.props.post_calculate_preOpso(calculate)   // temp commit to use create promo API
            } else {
              this.handle_createPromotion(this.props.draftData);
            }
          } else {
            CustomToast('error', "draft saved but some mandatory field empty")

          }
        }
        if (this.state.isdraft_iscreatePromotion === false) {
        }

        if (this.props.draftData.ActivityMetadata) { //Saving Data in IDB
          this.setState({
            isSaveDraft: false,
            durationData_props: this.props.draftData.ActivityMetadata
              ?.duration_detail,
            isInvoiceOn: this.props.draftData?.is_invoice_on
          });
          let response = SaveDraft.savedraftIn_idb(
            this.props.draftData.ActivityMetadata,
            this.props.draftData?.PreOpso
          );
          if (response === false) this.setState({ isSaveDraft: false });
        }
      }
    }
    setTimeout(() => {
      if (this.props.error !== undefined) {
        if (this.props.error && this.state.isLoading === true) {
          // ToastsStore.error("Save Draft Api failed ");
          CustomToast('error', "Save Draft Api failed ")
          this.setState({ isLoading: false });
        }
      }
    }, 1000);
    if (prevProps.promotionData !== this.props.promotionData) {
      console.log(this.props.promotionData.PreOpso.PreOpso)
      //check api response, is change
      // if (this.state.formName === 'mt') {
      //   if (this.props.promotionData?.PreOpso.guid) {
      //     this.props.draftData.PreOpso = this.props.promotionData.PreOpso.PreOpso;
      //     this.props.draftData.CanSubmit = this.props.promotionData.PreOpso.CanSubmit;
      //     this.props.draftData.main_metadata_changed = this.props.promotionData.main_metadata_changed;
      //     this.setState({
      //       counter: this.state.counter + 1,
      //       promotion_data: this.props.promotionData.PreOpso.PreOpso,
      //       isdraft_iscreatePromotion: false,
      //       isLoading: false,
      //       newto_savedraft: true,
      //     });
      //     setTimeout(() => {
      //       this.PreOpsoData(this.props.draftData?.PreOpso, true);
      //     }, 100);

      //     isPromotion_create = true;
      //   } else {

      //     this.setState({ isLoading: false });
      //   }
      // } else {
        if (this.props.promotionData.guid && this.props.draftData?.PreOpso) {
          this.props.draftData.PreOpso = this.props.promotionData.PreOpso;
          this.props.draftData.CanSubmit = this.props.promotionData.CanSubmit;
          this.props.draftData.main_metadata_changed = this.props.promotionData.main_metadata_changed;
          this.setState({
            counter: this.state.counter + 1,
            promotion_data: this.props.promotionData.PreOpso,
            isdraft_iscreatePromotion: false,
            isLoading: false,
            newto_savedraft: true,
          });
          setTimeout(() => {
            this.PreOpsoData(this.props.draftData?.PreOpso, true);
          }, 100);

          isPromotion_create = true;
        } else {

          this.setState({ isLoading: false });
        }
      // }
    }

    if (this.state.formName === "gt" || this.state.formName === "ic") {
      if (prevProps.submitApproval !== this.props.submitApproval) {
        if (this.props.submitApproval?.guid) {
          this.props.history.push("/promotionlist");
          CustomToast('success', "Submit Approval Api Success")
          this.setState({ isLoading: false });
        }
      }
      if (prevProps.submitApproval_error !== this.props.submitApproval_error) {
        CustomToast('error', "Submit Approval Api Failed because may be already exist")
        this.setState({ isLoading: false });
      }
    }
    if (this.state.formName === "mt") {
      if (prevProps.mtfts_submitApproval !== this.props.mtfts_submitApproval) {
        if (this.props.mtfts_submitApproval?.guid) {
          this.props.history.push("/promotionlist");
          CustomToast('success', "Submit Approval Api Success")
          this.setState({ isLoading: false });
        }
      }
      if (prevProps.submitApproval_error !== this.props.submitApproval_error) {
        CustomToast('error', "Submit Approval Api Failed because may be already exist")
        this.setState({ isLoading: false });
      }
    }
    if (this.props.promotionData !== prevProps.promotionData) {
      //check api reponse, is change
      if (this.props.promotionData?.guid) {
        SaveDraft.del_restriction_fromIdb();

      } else if (this.props.promotionData?.message) {
        CustomToast('error', this.props.promotionData.message)
        this.setState({ isLoading: false });
      }
    }

    if (this.props.pushToDwh !== prevProps.pushToDwh) {
      //check api response, is change
      if (this.props.pushToDwh === true) {
        CustomToast('success', "Pushed to data warehouse")
        SaveDraft.del_restriction_fromIdb();

        this.setState({
          pushed_to_dwh: true,
          isLoading: false,
          isDw_forProm: false,
        });
      }
    }
    if (
      this.props.isCreatePromotionError !== prevProps.isCreatePromotionError &&
      this.props.isCreatePromotionError !== undefined
    ) {
      this.setState({ isLoading: false });
    }
    if (this.props.extendedNewPromotion !== prevProps.extendedNewPromotion &&
      (this.props.extendedNewPromotion === true)) {
      this.state.isExtednNewPromotion === true && CustomToast('success', 'Successfully extended promotion created')
      SaveDraft.del_restriction_fromIdb();
      const { draftData } = this.props
      draftData.PreOpso = this.props.newExtensionData?.PreOpso
      this.setState({ isExtednNewPromotion: false, counter: 5, next: 5, isLoading: false })
    }
    if (this.props.calcError !== prevProps.calcError) {
      CustomToast('error', 'Extended New  Promotion api failed ')
      this.setState({ isLoading: false })
    }
  }

  componentWillUnmount() {
    SaveDraft.del_restriction_fromIdb();

    this.is_Mounted = false;
    this.setState = (state, callback) => {
      return;
    };
  }

  // following function is using to send back data from child to parent
  my_callback = (child_data, isSaveDraft) => {
    // connection of parent to child
    if (isSaveDraft) {
      isSaveDraft !== undefined ? this.saveDraft(true) : void 0;
    }
    this.setState({ isSaveDraft: child_data });
    if (child_data === true && this.state.counter !== 5) {
      isPromotion_create = false;
    }
  };

  msku_callBack = (data) => {
    // validation to check preopso msku, sending msku from pronotion.js
    this.setState({ msku_name: data });
  };

  saveDraft(flag) {
    if (flag === false) {
      return false;
    } else {
      this.setState({ isLoading: true });
      const getData = async () => {
        if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }
        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1

        const db = await openDB(dbName, version, {
          upgrade(db, oldVersion, newVersion, transaction) {
            const store = db.createObjectStore(storeName);       // eslint-disable-line
          },
        });
        const tx = await db.transaction(storeName, "readwrite");
        isPromotion_create =
          isPromotion_create === false
            ? false
            : this.state.counter !== 5
              ? false
              : true;

        await tx.dones;
        let data, txs, obj;       // eslint-disable-line
        data = await db;
        txs = await data.transaction(storeName);
        obj = await tx.objectStore(storeName);
        let productData = await obj.get("product_detail");
        let channelData = await obj.get("channel_detail");
        let geoData = await obj.get("geo_detail");
        let outletData = await obj.get("outlet_detail");
        let durationData = await obj.get("duration_detail");
        let PreOpso = await obj.get("preopso_detail");
        let contributionData = await obj.get("contribution_detail");

        //flag values
        let geoFlagData = await obj.get('selectedAllGeoFlags')
        let channelFlagData = await obj.get('selectedAllChannelFlags')
        let outletFlagData = await obj.get('selectedAllOutletFlags')

        PreOpso = PreOpso?.value;
        if (
          productData ||
          channelData ||
          geoData ||
          outletData ||
          durationData ||
          contributionData
        ) {
          if (
            productData ||
            channelData ||
            geoData ||
            outletData ||
            durationData ||
            contributionData
          ) {
            productData = productData
              ? productData.value[0]
                ? productData.value[0]
                : productData.value
              : [];
            geoData = geoData
              ? geoData.value[0]
                ? geoData.value[0]
                : geoData.value
              : [];
            channelData = channelData
              ? channelData.value[0]
                ? channelData.value[0]
                : channelData.value
              : [];
            outletData = outletData
              ? outletData.value[0]
                ? outletData.value[0]
                : outletData.value
              : [];
            durationData = durationData
              ? durationData.value[0]
                ? durationData.value[0]
                : durationData.value
              : [];
            contributionData = contributionData
              ? contributionData.value
              : [];
            let filtered_durationData = [];
            durationData &&
              filtered_durationData.push({
                year: durationData.year,
                IsDate: durationData.IsDate,
                WeekStart: durationData.WeekStart,
                WeekEnd: durationData.WeekEnd,
                DateStart: durationData.DateStart,
                DateEnd: durationData.DateEnd,
              });
            let isDraftId = window.location.pathname.substr(8);
            mainMetaDataChangeFlag = this.mainMetaDataChangeCheck(this.props.draftData, productData, filtered_durationData[0], geoData);
            let checkFlag = (this.props.draftData?.main_metadata_changed === false && mainMetaDataChangeFlag === false) ? false :
              (this.props.draftData?.main_metadata_changed === true && (mainMetaDataChangeFlag === true || mainMetaDataChangeFlag === false)) ? true :
                // (this.props.draftData?.main_metadata_changed === true && mainMetaDataChangeFlag === false) ? true :
                mainMetaDataChangeFlag
            let data = {}
            if (this.state.formName === 'gt' || this.state.formName === 'ic') {
              data = {
                ActivityMetadata: {
                  product_detail: productData,
                  geographic_detail: geoData,
                  channel_detail: channelData,
                  outlet_attributes: outletData,
                  duration_detail: filtered_durationData[0],
                  select_all_flags: {
                    geographic_detail: geoFlagData ? geoFlagData.value[0] ? geoFlagData.value[0] : geoFlagData.value : [],
                    channel_detail: channelFlagData ? channelFlagData.value[0] ? channelFlagData.value[0] : channelFlagData.value : [],
                    outlet_detail: outletFlagData ? outletFlagData.value[0] ? outletFlagData.value[0] : outletFlagData.value : []
                  }
                },
                PreOpso: PreOpso ? PreOpso : {},
                guid: isDraftId,
                CanSubmit: this.props.draftData?.IsExtended === true ? true : this.props.draftData?.CanSubmit === false ||
                  this.state.isNew_Restrict === true ? false : this.state.counter === 5 ? true : false,
                main_metadata_changed: checkFlag,
                is_invoice_on: this.state.isInvoiceOn
              };
            }
            else if (this.state.formName === 'mt') {
              console.log(contributionData)
              data = {
                ActivityMetadata: {
                  product_detail: productData,
                  geographic_detail: geoData,
                  channel_detail: channelData,
                  outlet_attributes: outletData,
                  duration_detail: filtered_durationData[0],
                  contribution_detail: contributionData,
                  select_all_flags: {
                    geographic_detail: geoFlagData ? geoFlagData.value[0] ? geoFlagData.value[0] : geoFlagData.value : []
                  }
                },
                PreOpso: PreOpso ? PreOpso : {},
                guid: isDraftId,
                CanSubmit: this.props.draftData?.IsExtended === true ? true : this.props.draftData?.CanSubmit === false ||
                  this.state.isNew_Restrict === true ? false : this.state.counter === 5 ? true : false,
                main_metadata_changed: checkFlag
              };
            }

            let jsonData = JSON.stringify(data);       // eslint-disable-line
            const isNewPromotion = await obj.get("is_newPromotion");
            (await isDraftId) &&
              this.props.post_updateDraft({ ...data }, this.props.history, (isNewPromotion && this.props.draftData?.IsExtended === false) ? false : true);
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);

            // Make a request to delete the specified record out of the object store
            let objectStoreRequest = objectStore.delete("is_draft_saved");       // eslint-disable-line
          }
        }
      };

      getData();
    }
  }

  mainMetaDataChangeCheck(apiData, productDetailData, durationDetailData, geoData) {
    if (apiData?.ActivityMetadata?.product_detail?.promotion_type && productDetailData && durationDetailData && this.state.formName !== 'mt') {
      return (this.changeInProductDetailData(apiData, productDetailData, geoData) || this.changeInDurationData(apiData, durationDetailData)) ? true : false
    }
    else if (apiData?.ActivityMetadata?.product_detail?.promotion_type && productDetailData && durationDetailData && geoData && this.state.formName === 'mt') {
      return (this.changeInProductDetailData(apiData, productDetailData, geoData) || this.changeInDurationData(apiData, durationDetailData)) ? true : false
    }
    else {
      return false
    }
  }

  changeInDurationData(apiData, durationDetailData) {
    if (apiData?.ActivityMetadata?.duration_detail?.year) {
      let yearChange = apiData?.ActivityMetadata?.duration_detail?.year === durationDetailData.year ? false : true;
      let startWeekChange = apiData?.ActivityMetadata?.duration_detail?.WeekStart === durationDetailData.WeekStart ? false : true;
      let endWeekChange = apiData?.ActivityMetadata?.duration_detail?.WeekEnd === durationDetailData.WeekEnd ? false : true;
      return (yearChange || startWeekChange || endWeekChange) ? true : false;

    } else {
      return false;
    }
  }

  changeInProductDetailData(apiData, productDetailData, geoData) {

    let promotionTypeChange = apiData.ActivityMetadata.product_detail.promotion_type === productDetailData.promotion_type ? false : true;
    let categoriesChange = this.productDataFieldChange(apiData.ActivityMetadata.product_detail.categories, productDetailData.categories);
    let brandsChange = this.productDataFieldChange(apiData.ActivityMetadata.product_detail.brands, productDetailData.brands);

    if (this.state.formName === 'mt') {
      let customerChange = this.productDataFieldChange(apiData.ActivityMetadata.product_detail.direct_customers, productDetailData.direct_customers);
      let masterSkuChange = this.productDataFieldChange(apiData.ActivityMetadata.product_detail.master_skus, productDetailData.master_skus);
      let skuChange = this.productDataFieldChange(apiData.ActivityMetadata.product_detail.skus, productDetailData.skus);
      let skuVariantsChange = this.productDataFieldChange(apiData.ActivityMetadata.product_detail.sku_variants, productDetailData.sku_variants);
      let skuFormatChange = this.productDataFieldChange(apiData.ActivityMetadata.product_detail.skus_formats, productDetailData.skus_formats);
      let skuSizeChange = this.productDataFieldChange(apiData.ActivityMetadata.product_detail.sku_size, productDetailData.sku_size);
      let regionChange = this.productDataFieldChange(apiData.ActivityMetadata.geographic_detail.regions, geoData.regions);
      let distributorChange = this.productDataFieldChange(apiData.ActivityMetadata.geographic_detail.distributors, geoData.distributors);

      return (customerChange || categoriesChange || brandsChange || masterSkuChange
        || skuChange || skuVariantsChange || skuFormatChange || skuSizeChange || regionChange
        || distributorChange) ? true : false;
    } else {
      return (promotionTypeChange || categoriesChange || brandsChange) ? true : false;
    }
  }

  productDataFieldChange(apiData, dbData) {
    let count = 0;
    if (apiData && dbData) {
      apiData.filter((value) => dbData.includes(value) ? count++ : null)    //if api contains same data then count is incremented
    }
    return count !== 0 ? false : true       //if any data is same count is not 0 then so it will return false
  }

  post_submitApi(isPush_todw) {
    this.setState({ submitActivity_Status: "execute", isLoading: true });
    let submit_helper = GtFormHelpers_submitHelper.submit_helper(
      isPush_todw,
      this.props.draftData,
      this.props.product_master_skus,
      this.state.formName,
      this.props.old_preOpso,
      this.props.isExtended
    );
    if (submit_helper === false) {
      return this.setState({ isLoading: false });
    } else if (submit_helper === "push_to_dw") return this.push_to_dwh();
    else if (submit_helper?.key === "submit_approval")
      return this.props.post_submitApproval(
        this.props.draftData?.guid,
        submit_helper?.pair
      );
    else if (submit_helper === "submit_approval_without_param")
      return this.props.post_submitApproval(this.props.draftData?.guid, "");
    else if (submit_helper === "mtfts_submit_approval_without_param")
      return this.props.post_mtfts_submitApproval(
        this.props.draftData?.guid,
        ""
      );
  }

  approval_submitHandler = (flag) => {
    if (this.state.formName === 'ic') {
      this.setState({ isPush_For_saveDraft: flag });
      if (this.state.isSaveDraft === true) {
        this.setState({ submitActivity_Status: "initial" });
      }
      setTimeout(() => {
        if (
          this.state.submitActivity_Status === "initial" &&
          this.state.isSaveDraft === true
        ) {
          this.saveDraft(true);
          this.setState({ submitActivity_Status: "pending" });
        } else if (this.state.isSaveDraft !== true) {
          this.post_submitApi(flag);
        }
      }, 10);
    }
    else {
      if (this.state.isCalculateBtnClicked) {
        this.setState({ isPush_For_saveDraft: flag });
        if (this.state.isSaveDraft === true) {
          this.setState({ submitActivity_Status: "initial" });
        }
        setTimeout(() => {
          if (
            this.state.submitActivity_Status === "initial" &&
            this.state.isSaveDraft === true
          ) {
            this.saveDraft(true);
            this.setState({ submitActivity_Status: "pending" });
          } else if (this.state.isSaveDraft !== true) {
            this.post_submitApi(flag);
          }
        }, 10);
      }
      else {
        CustomToast('warning', 'Please click on Calculate button before submitting');
      }
    }
  };

  handleIsCalculateButtonClicked = (value) => {
    if (value) {
      this.setState({
        isCalculateBtnClicked: true
      })
    } else {
      this.setState({
        isCalculateBtnClicked: false
      })
    }
  }

  handleANPChange = (value) => {
    this.setState(
      {
        ANP: value,
      }
    );
  };

  isLoadingProps = (isLoader) => {
    if (isLoader === true) {
      this.setState({ isLoading: true, counter: 5 });
    } else {
      // ToastsStore.success("false");
      CustomToast('success', "false")
      this.setState({ isLoading: false, counter: 5 });
    }
  };

  // validation for submit promotion using indexed db
  isRestrict_fromIdb = (value, prom) => {
    if (value) {
      this.setState({ pushed_to_dwh: false });
    }
    if (prom) {
      this.setState({ isDw_forProm: true });
    } else {
      this.setState({ isNew_Restrict: value });
    }
  };

  outletUpdatedSummary = (value, saveForDraft) => {
    this.setState({
      outletCodes: value,
      saveOutletCodesDraft: saveForDraft,
    });
  };

  push_to_dwh = () => {
    try {
      this.props.post_push_to_dwh(this.props.draftData?.guid);
    } catch (e) {
    } finally {
      this.setState({ isLoading: true });
    }
  };

  handleHistorySideBar = () => {
    this.setState({
      openHistory: !this.state.openHistory,
    });
  };
  hanldeOldActivity = () => {
    let status = 'Extended By ACOM'
    window.open(`/promotionapproval/${this.props.old_preOpso?.guid}?activity_status=${status}&${this.props.old_preOpso?.activity_code}`, '_blank')
  }

  handleInvoiceToggle = () => {
    this.setState({
      isInvoiceOn: !this.state.isInvoiceOn
    })
  }

  handleGetPromoType = (value) => {
    // console.log(value)
    this.setState({
      productDetailPromoType: value
    })
  }



  render() {
    const { counter, next } = this.state;
    return this.state.isLoading === true ? (
      <Loader flag={true} />
    ) : (
      <>
        {" "}
        {this.is_Mounted === true && (
          <div className="gt_form_main">
            {this.state.openHistory ? (
              <ApprovalHistory
                isOpen={this.state.openHistory}
                handleHistorySideBar={this.handleHistorySideBar}
                approvalHistory={
                  this.props?.sendbackHistory?.length
                    ? this.props.sendbackHistory
                    : []
                }
              />
            ) : null}
            <div className="gt_form_header">
              <div className="rotate_section">
                <div></div>
                <div className="">
                  <ul className="stepper_ul">
                    <li
                      className="active_stepper_circle"
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 0 });
                        }, 10);
                        this.setState({ next: 0 });
                      }}
                    ></li>
                    <li
                      className={
                        counter >= 1 ? "active_stepper_line" : "stepper_line_li"
                      }
                    ></li>
                    <li
                      className={
                        counter === 0 ? "active_stepper_text" : "stepper_text"
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 0 });
                        }, 10);
                        this.setState({ next: 0 });
                      }}
                    >
                      {" "}
                      Product Detail{" "}
                    </li>
                  </ul>
                </div>
                <div className="">
                  <ul className="stepper_ul">
                    <li
                      className={
                        counter >= 1
                          ? "active_stepper_circle"
                          : "stepper_circle_li"
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 1 });
                        }, 10);
                        this.setState({ next: 1 });
                      }}
                    ></li>
                    <li
                      className={
                        counter >= 2 ? "active_stepper_line" : "stepper_line_li"
                      }
                    ></li>
                    <li
                      className={
                        counter === 1 ? "active_stepper_text" : "stepper_text"
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 1 });
                        }, 10);
                        this.setState({ next: 1 });
                      }}
                    >
                      {" "}
                      Geograhic Detail{" "}
                    </li>
                  </ul>
                </div>
                {/* {(this.state.formName === "gt" || this.state.formName === "ic") && ( */}
                <div className="">
                  <ul className="stepper_ul">
                    <li
                      className={
                        counter >= 2
                          ? "active_stepper_circle"
                          : "stepper_circle_li"
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 2 });
                        }, 10);
                        this.setState({ next: 2 });
                      }}
                    ></li>
                    <li
                      className={
                        counter >= 3
                          ? "active_stepper_line"
                          : "stepper_line_li"
                      }
                    ></li>
                    <li
                      className={
                        counter === 2 ? "active_stepper_text" : "stepper_text"
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 2 });
                        }, 10);
                        this.setState({ next: 2 });
                      }}
                    >
                      {this.state.formName === 'mt' ? 'Contribution Detail' : 'Channel Detail'}
                    </li>
                  </ul>
                </div>
                {/* )} */}
                {(this.state.formName === "gt" || this.state.formName === "ic") && (
                  <div className="">
                    <ul className="stepper_ul">
                      <li
                        className={
                          counter >= 3
                            ? "active_stepper_circle"
                            : "stepper_circle_li"
                        }
                        onClick={() => {
                          setTimeout(() => {
                            this.setState({ counter: 3 });
                          }, 10);
                          this.setState({ next: 3 });
                        }}
                      ></li>
                      <li
                        className={
                          counter >= 4
                            ? "active_stepper_line"
                            : "stepper_line_li"
                        }
                      ></li>
                      <li
                        className={
                          counter === 3
                            ? "active_stepper_text outlet_sec"
                            : "stepper_text outlet_sec"
                        }
                        onClick={() => {
                          setTimeout(() => {
                            this.setState({ counter: 3 });
                          }, 10);
                          this.setState({ next: 3 });
                        }}
                      >
                        {" "}
                        Outlet Detail{" "}
                      </li>
                    </ul>
                  </div>
                )}
                <div className="">
                  <ul className="stepper_ul">
                    <li
                      className={
                        counter >= 4
                          ? "active_stepper_circle"
                          : "stepper_circle_li"
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 4 });
                        }, 10);
                        this.setState({ next: 4 });
                      }}
                    ></li>
                    <li
                      className={
                        counter >= 5 ? "active_stepper_line" : "stepper_line_li"
                      }
                    ></li>
                    <li
                      className={
                        counter === 4
                          ? "active_stepper_text outlet_sec"
                          : "stepper_text outlet_sec"
                      }
                      style={
                        counter
                          ? { cursor: "pointer", pointerEvents: "auto" }
                          : { cursor: "pointer", pointerEvents: "auto" }
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 4 });
                        }, 10);
                        this.setState({ next: 4 });
                      }}
                    >
                      {" "}
                      Duration Detail{" "}
                    </li>
                  </ul>
                </div>
                <div className="">
                  <ul className="stepper_ul">
                    <li
                      className={
                        counter >= 5
                          ? "last_circle active_stepper_circle"
                          : "stepper_circle_li"
                      }
                      style={
                        this.state.newto_savedraft === false &&
                          this.props.newDraft?.guid
                          ? {
                            pointerEvents: "none",
                            cursor: "notAllowed",
                            display: "flex",
                          }
                          : this.props.draftData?.PreOpso?.Promotions
                            ? { display: "flex" }
                            : {
                              pointerEvents: "none",
                              cursor: "notAllowed",
                              display: "flex",
                            }
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 5 });
                        }, 10);
                        this.setState({ next: 5 });
                      }}
                    ></li>
                    <li
                      className={
                        counter === 5 ? "active_stepper_text" : "stepper_text"
                      }
                      style={
                        this.state.newto_savedraft === false &&
                          this.props.newDraft?.guid
                          ? {
                            pointerEvents: "none",
                            cursor: "notAllowed",
                            position: "relative",
                            right: "1.55em",
                          }
                          : (this.props.draftData?.PreOpso?.Promotions || this.props.draftData?.PreOpso?.PreOpso?.Promotions)
                            ? { position: "relative", right: "1.55em" }
                            : {
                              pointerEvents: "none",
                              cursor: "notAllowed",
                              position: "relative",
                              right: "1.55em",
                            }
                      }
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({ counter: 5 });
                        }, 10);
                        this.setState({ next: 5 });
                      }}
                    >
                      Promotion{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="gt_form_body">
              <div className="stepper_body">
                {counter === 0 ? (
                  <ProductDetail
                    currentForm={this.state.formName}
                    counter={this.state.next}
                    call_back={this.my_callback}
                    draftData={this.props.draftData && this.props.draftData}
                    draft_state={this.state.isSaveDraft}
                    isRestrict_fromIdb={this.isRestrict_fromIdb}
                    getPromoTypeCallback={this.handleGetPromoType}
                    isInvoiceOn={this.state.isInvoiceOn}
                    handleInvoiceToggle={this.handleInvoiceToggle}
                    apiData={this.props?.draftData?.ActivityMetadata?.product_detail}
                  />
                ) : counter === 1 ? (
                  <GeographicDetail
                    currentForm={this.state.formName}
                    draftData={this.props.draftData && this.props.draftData}
                    counter={this.state.next}
                    call_back={this.my_callback}
                    draft_state={this.state.isSaveDraft}
                    isRestrict_fromIdb={this.isRestrict_fromIdb}
                  />
                ) : counter === 2 ? (
                  <>
                    {
                      this.state.formName === 'mt' ?
                        <ContributionDetail
                          currentForm={this.state.formName}
                          draftData={this.props.draftData && this.props.draftData}
                          counter={this.state.next}
                          call_back={this.my_callback}
                          draft_state={this.state.isSaveDraft}
                          isRestrict_fromIdb={this.isRestrict_fromIdb}
                          isInvoiceOn={this.state.isInvoiceOn}
                        />
                        :
                        <ChannelDetail
                          currentForm={this.state.formName}
                          draftData={this.props.draftData && this.props.draftData}
                          counter={this.state.next}
                          call_back={this.my_callback}
                          draft_state={this.state.isSaveDraft}
                          isRestrict_fromIdb={this.isRestrict_fromIdb}
                          isInvoiceOn={this.state.isInvoiceOn}
                        />
                    }
                  </>
                ) : counter === 3 ? (
                  <Outlet
                    currentForm={this.state.formName}
                    counter={this.state.next}
                    call_back={this.my_callback}
                    draft_state={this.state.isSaveDraft}
                    isUpdateSummary={this.outletUpdatedSummary}
                    outletCodes={this.state.outletCodes}
                    saveOutletCodesDraft={this.state.saveOutletCodesDraft}
                    isRestrict_fromIdb={this.isRestrict_fromIdb}
                  />
                ) : counter === 4 ? (
                  <Duration
                    currentForm={this.state.formName}
                    counter={this.state.next}
                    call_back={this.my_callback}
                    draft_state={this.state.isSaveDraft}
                    data_binding={this.duration_callBack}
                    isRestrict_fromIdb={this.isRestrict_fromIdb}
                  />
                ) : counter === 5 ? (
                  <>
                    {
                      this.state.formName === 'mt' ?
                        <MTFTSPromotion
                          currentForm={this.state.formName}
                          counter={this.state.next}
                          call_back={this.my_callback}
                          handleANPChangeProp={this.handleANPChange}
                          draft_state={this.state.isSaveDraft}
                          isLoadingProps={this.isLoadingProps}
                          isRestrict_fromIdb={this.isRestrict_fromIdb}
                          preOpso_data={this.state.preOpso_data}
                          handleIsCalculateButtonClicked={this.handleIsCalculateButtonClicked}
                        />
                        :
                        <Promotion
                          currentForm={this.state.formName}
                          counter={this.state.next}
                          call_back={this.my_callback}
                          handleANPChangeProp={this.handleANPChange}
                          draft_state={this.state.isSaveDraft}
                          isLoadingProps={this.isLoadingProps}
                          isRestrict_fromIdb={this.isRestrict_fromIdb}
                          preOpso_data={this.state.preOpso_data}
                          handleIsCalculateButtonClicked={this.handleIsCalculateButtonClicked}
                        />
                    }
                  </>
                ) : (
                  void 0
                )}
              </div>
              {counter === 5 ? (
                <div>
                  {(this.state.currentActivityStatus === "Sent Back By CDF" ||
                    this.state.currentActivityStatus === "Sent Back By CDFM" ||
                    this.state.currentActivityStatus === "Sent Back By CMD" ||
                    this.state.currentActivityStatus === "Extended By ACOM")
                    // (this.state.counter === 5) 
                    ? (
                      <div
                        style={{
                          width: "fit-content",
                          left: "30px",
                          bottom: "50px",
                          position: "absolute",
                        }}
                      >
                        <span
                          style={{ color: "#3f7fc9", cursor: "pointer" }}
                          onClick={this.handleHistorySideBar}
                        >
                          <u>View Approval History</u>
                        </span>
                        {this.props.draftData?.IsExtended === true ?
                          <span
                            style={{
                              width: "fit-content",
                              color: "black", cursor: "pointer",
                              marginLeft: '1.2vw'
                            }}
                            onClick={this.hanldeOldActivity}
                          // className='old_app'

                          >
                            <u>View Original Activity</u>
                          </span> : void 0}
                      </div>
                    )
                    : this.props.draftData?.IsExtended === true ?
                      <span

                        onClick={this.hanldeOldActivity}
                        // className='old_app'
                        style={{
                          width: "fit-content",
                          left: "30px",
                          bottom: "50px",
                          position: "absolute",
                          color: "black", cursor: "pointer",
                          marginLeft: '1.2vw'

                        }}
                      >
                        <u>View Original Activity</u>
                      </span>
                      : null}
                  <div className="stepper_counter">
                    <button
                      style={
                        this.props.isApiLoading === true ||
                          this.state.pushed_to_dwh === true
                          ? { pointerEvents: "none" }
                          : void 0
                      }
                      className={

                        (isPromotion_create === false ||
                          this.state.isNew_Restrict === true || this.props.draftData?.CanSubmit === false)
                          ? "cts_not_allowed stepper_btn_back"
                          : "stepper_btn_back"
                      }
                      onClick={
                        (this.state.isNew_Restrict !== true || this.props.draftData?.CanSubmit === true ||
                          this.state.isDw_forProm === true) &&
                        this.approval_submitHandler.bind(this, true)
                      }
                    >
                      {(this.state.pushed_to_dwh === true || this.props.draftData?.PushToDwh)
                        ? "Pushed"
                        : "Push to DWH"}
                      {isPromotion_create === false ||       // eslint-disable-line
                        (this.state.isNew_Restrict === true || this.props.draftData?.CanSubmit === false) && (       // eslint-disable-line
                          <p
                            className="warning_message"
                            style={{
                              border: "1px solid #ffffff",
                              pointerEvents: "none",
                            }}
                          >
                            You have changed Metadata, please re calculate
                            pre-opso
                          </p>
                        )}
                    </button>


                    <button
                      style={
                        this.props.isApiLoading === true
                          ? { pointerEvents: "none" }
                          : void 0
                      }
                      className={
                        (
                          // isPromotion_create === false||
                          this.state.isNew_Restrict === true || this.props.draftData?.CanSubmit === false)
                          ? "cts_not_allowed stepper_btn_next"
                          : "stepper_btn_next"
                      }
                      onClick={
                        (this.state.isNew_Restrict !== true && this.props.draftData?.CanSubmit === true) &&
                        this.approval_submitHandler.bind(this, false)
                      }
                    >
                      Submit
                      {(
                        // isPromotion_create === false ||
                        this.state.isNew_Restrict === true || this.props.draftData?.CanSubmit === false)
                        && (
                          <p
                            className="warning_message"
                            style={{
                              border: "1px solid #ffffff",
                              pointerEvents: "none",
                            }}
                          >
                            You have changed Metadata, please re calculate
                            pre-opso
                          </p>
                        )}
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="stepper_counter">
                    <button
                      className="stepper_btn_back"
                      style={
                        counter === 0
                          ? {
                            pointerEvents: "none",
                            cursor: "notAllowed",
                            display: "none",
                          }
                          : void 0
                      }
                      onClick={() => {
                        if (counter >= 1) {
                          setTimeout(() => {
                            this.setState({
                              counter:
                                counter === 4 && this.state.formName === "mt"
                                  ? counter - 2
                                  : counter - 1,
                            });
                          }, 10);
                          this.setState({
                            next:
                              next === 4 && this.state.formName === "mt"
                                ? next - 2
                                : next - 1,
                          });
                        }
                      }}
                    >
                      Back
                    </button>

                    {counter === 4 ? (
                      <button
                        title="Pulls the AWS Baselines, Inc AWS and Post AWS from the model always based on the given norm and norm type, which will result in the override of user input values for these metrics (if applies). The trigger will be effective to use only when the promotion is created for the very first time or when there is a user defined change in promotion attribute(s)."
                        className="stepper_btn_next"
                        onClick={

                          this.onSubmit.bind(this)}
                      >
                        Create Promotion
                      </button>
                    ) : (
                      <button
                        className="stepper_btn_next"
                        style={
                          counter === 5
                            ? { pointerEvents: "none", cursor: "notAllowed" }
                            : void 0
                        }
                        onClick={() => {
                          setTimeout(() => {
                            this.setState({
                              counter:
                                counter === 2 && this.state.formName === "mt"
                                  ? counter + 2
                                  : counter + 1,
                            });
                          }, 10);
                          this.setState({
                            next:
                              next === 2 && this.state.formName === "mt"
                                ? next + 2
                                : next + 1,
                          });
                        }}
                      >
                        Next{" "}
                      </button>
                    )}
                  </div>
                </div>
              )}

              <div className="save_as_draft">
                <ul className="draft_ul">
                  <li className="draft_img">
                    <img src={require("../gt/images/draft.svg")} alt='' />
                  </li>
                  <li
                    className="draft_text"
                    onClick={this.saveDraft.bind(this, this.state.isSaveDraft)}
                    style={
                      this.state.isSaveDraft !== true
                        ? { pointerEvents: "none", cursor: "notAllowed" }
                        : void 0
                    }
                  >
                    {this.state.isLoading === true
                      ? "Loading...."
                      : this.state.isSaveDraft === false
                        ? "Saved"
                        : "Save draft"}

                  </li>

                </ul>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

// Redux
const mapStateToProps = (state) => {
  return {
    form: state,
    category: state.CategoryReducer.category,
    promotionResponse: state.CreatePromotionReducer.promotionResponse,
    promotionData: state.CreatePromotionReducer.promotionData,
    draftData: state.CreatePromotionReducer.draftData,
    newDraft: state.CreatePromotionReducer.newDraft,
    formType: state.CreatePromotionReducer.type,
    error: state.CreatePromotionReducer.error,
    submitApproval: state.ApprovalReducer.submitApproval,
    mtfts_submitApproval: state.ApprovalReducer.mtfts_submitApproval,
    submitApproval_error: state.ApprovalReducer.error,
    isApiLoading: state.CreatePromotionReducer.isCreatePromotionLoading,
    pushToDwh: state.CreatePromotionReducer.pushToDwh,
    isCreatePromotionError: state.CreatePromotionReducer.isCreatePromotionError,
    product_master_skus: state.ProductReducer.productMasterSkus,
    sendbackHistory: state.ApprovalReducer.sendbackHistory,
    old_preOpso: state.ApprovalReducer.old_preOpso,
    isExtended: state.CreatePromotionReducer.isExtended,
    extendedNewPromotion: state.CreatePromotionReducer.extendedNewPromotion,
    calcError: state.CreatePromotionReducer.calcError,
    newExtensionData: state.CreatePromotionReducer.newExtensionData,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createPromotion: (apiBody) => {
      return dispatch(CreatePromotion.post_createPromotion(apiBody));
    },
    createPromotionmtfts: (apiBody) => {
      return dispatch(CreatePromotion.post_createPromotionmtfts(apiBody));
    },
    post_updateDraft: (data, history, isNewPromotion) => {
      return dispatch(CreatePromotion.post_updateDraft(data, history, isNewPromotion));
    },
    get_saveDraft: (id) => {
      return dispatch(CreatePromotion.get_saveDraft(id));
    },
    post_submitApproval: (__id, data, flag) => {
      return dispatch(
        ApprovalsMiddleware.post_submitApproval(__id, data, flag)
      );
    },
    post_mtfts_submitApproval: (__id, data, flag) => {
      return dispatch(
        ApprovalsMiddleware.post_mtfts_submitApproval(__id, data, flag)
      );
    },
    post_push_to_dwh: (_id) => {
      return dispatch(CreatePromotion.post_push_to_dwh(_id));
    },
    getSendBackHistory: (data) => {
      return dispatch(ApprovalsMiddelware.getSendBackHistory(data));
    },
    getOldPreopso: (_guid) => {
      return dispatch(ApprovalsMiddleware.getOldPreopso(_guid));
    },
    post_calculate_preOpso: (data) => {
      return dispatch(CreatePromotion.post_calculate_preOpso(data));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(GtForm);
